(function (Drupal, once) {
  Drupal.behaviors.carsChart = {
    attach(context) {

      const canvas = once('cars-chart', '#cars-chart', context)[0];
      if (!canvas) return;

      let labels = [];
      let values = [];
      let counts = [];

      try {
        labels = JSON.parse(canvas.dataset.labels || '[]');
        values = JSON.parse(canvas.dataset.values || '[]');
        counts = JSON.parse(canvas.dataset.counts || '[]');
      } catch (e) {
        console.warn('Chart data missing or invalid', e);
        return;
      }

      if (!labels.length || !values.length) {
        console.warn('No chart data available');
        return;
      }

      new Chart(canvas, {
        type: 'doughnut',
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: [
              '#2152ff',
              '#e91e63',
              '#3A416F',
              '#a8b8d8',
              '#fb8c00',
              '#17c1e8',
              '#4caf50',
              '#ff9800',
            ],
            borderWidth: 1,
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label(context) {
                  const index = context.dataIndex;
                  const value = context.parsed;
                  const count = counts[index] ?? 0;

                  return `${value.toFixed(2)} € (${count} ремонта)`;
                }
              }
            },
            legend: {
              position: 'bottom',
              labels: {
                padding: 20,
                boxWidth: 14,
                font: {
                  size: 13,
                }
              }
            }
          },
        }
      });
    }
  };
})(Drupal, once);
